import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor() {
    this.requestPermission();
  }

  private requestPermission() {
    if ('Notification' in window) {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          console.warn('Notificaciones permitidas .');
        } else {
          console.warn('Permiso para notificaciones no concedido.');
        }
      });
    } else {
      console.error('La API de Notificaciones no está soportada en este navegador.');
    }
  }

  // Método para manejar el clic del botón
  handleButtonClick(message: string) {
     return this.showNotification (message);

  }
  public showNotification(message: string, title: string = 'Notificación') {
    // console.log('showNotification  : '+Notification.permission);
    if ('Notification' in window) {
      if (Notification.permission === 'granted') {
        new Notification(title, {
          body: message,
          icon: 'assets/icons/notificacion.png'
        });
      } else if (Notification.permission !== 'denied') {
        this.requestPermission();
      } else {
        console.error('Permiso de notificación denegado.');
      }
    } else {
      console.error('La API de Notificaciones no está soportada en este navegador.');
    }
    return Notification.permission ;
  }
  
}
